import React, { useEffect } from "react";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });

    return matches;
};

export default function Device() {
    const types = {
        mobile: useMediaQuery('(max-width: 1152px)'),
        tablet: false,
        desktop: true
    };

    const sizes = {
        xxl: true,
        xl: useMediaQuery('(max-width: 2200px)'),
        lg: useMediaQuery('(max-width: 1920px)'),
        md: useMediaQuery('(max-width: 1280px)'),
        sm: useMediaQuery('(max-width: 960px)'),
        xs: useMediaQuery('(max-width: 600px)'),
        xxs: useMediaQuery('(max-width: 300px)')
    };

    var device = {
        type: "",
        size: "",
        sizes: sizes,
        get isMobile() { return this.type === "Mobile"; },
        get isXxs() { return this.sizes.xxs; },
        get isXs() { return this.sizes.xs; },
        get isSm() { return this.sizes.sm; },
        get isMd() { return this.sizes.md; },
        get isLg() { return this.sizes.lg; },
        get isXl() { return this.sizes.xl; }
    };

    if (types.mobile)
        device.type = "Mobile";
    else if (types.tablet)
        device.type = "Tablet";
    else
        device.type = "Desktop";

    if (sizes.xxs)
        device.size = "xxs";
    else if (sizes.xs)
        device.size = "xs";
    else if (sizes.sm)
        device.size = "sm";
    else if (sizes.md)
        device.size = "md";
    else if (sizes.lg)
        device.size = "lg";
    else if (sizes.xl)
        device.size = "xl";
    else
        device.size = "xxl";

    return device;
};